import { render, staticRenderFns } from "./WxDispatchPage.vue?vue&type=template&id=ae7b75f8&scoped=true&"
import script from "./WxDispatchPage.vue?vue&type=script&lang=js&"
export * from "./WxDispatchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7b75f8",
  null
  
)

export default component.exports